import { Grid } from "@mui/material";
import OutletCard from "./OutletCard";
import OutletSummary from "./OutletSummary";

const OutletList = ({
    outlets,
    offerIndex,
    offer,
    selectedOutlets,
    expandedProductIndex,
    onOutletCheckboxChange,
    onToggleProductRow,
    getSelectedOutletsCountForOffer,
}) => {
    return (
        <>
            {/* Individual Outlet Cards */}
            <Grid container spacing={2.5}>
                {outlets.map((outlet, outletIndex) => {
                    const outletKey = `${offerIndex}_${outletIndex}`;
                    const isSelected = selectedOutlets[outletKey];
                    const isExpanded = expandedProductIndex[outletKey];

                    return (
                        <Grid item xs={12} key={outletIndex}>
                            <OutletCard
                                outlet={outlet}
                                offerIndex={offerIndex}
                                outletIndex={outletIndex}
                                offer={offer}
                                isSelected={isSelected}
                                isExpanded={isExpanded}
                                onOutletCheckboxChange={onOutletCheckboxChange}
                                onToggleProductRow={onToggleProductRow}
                            />
                        </Grid>
                    );
                })}
            </Grid>

            {/* Summary Section */}
            {getSelectedOutletsCountForOffer(offerIndex, outlets) > 0 && (
                <OutletSummary
                    offerIndex={offerIndex}
                    outlets={outlets}
                    selectedOutlets={selectedOutlets}
                    getSelectedOutletsCountForOffer={getSelectedOutletsCountForOffer}
                />
            )}
        </>
    );
};

export default OutletList;